import { Icon, Tooltip, Typography } from "@plum-xoxo/admin-dsm";
import React, { useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  app_path,
  festiveGifting,
  exclusive,
  bulkGifting,
  diwaliGifting,
  intercomChecklistId,
  intercomChecklistIdNonKyb,
  holidayGifting,
  holidayGiftingCurrencies,
} from "config";
import { useState } from "react";
import theme from "../../theme";
import FestiveGifting from "../Header/FestiveGifting";
import Exclusive from "../Header/Exclusive";
import BulkGifting from "../Header/BulkGifting";
import Balance from "./Balance";
import BulkUploadProgress from "../BulkProcess/BulkUploadProgress";
import { getEventRewardOptions } from "./constants";
import { ACL_MODULE_MAPPING } from "../../constants/RouteConstant";
import { startChecklist } from "@intercom/messenger-js-sdk";

const SubOption = styled(Typography.HelperText).attrs()`
  background-color: ${(props) =>
    props.active ? props.theme.palette.primary.c00 : ""};
  color: ${(props) =>
    props.active
      ? props.theme.palette.primary.c03
      : props.theme.palette.dark.c300};
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 0px;
  cursor: pointer;
`;

const OptionSideBar = ({
  title = "",
  options = [],
  onClick = null,
  accountReducer,
  activeTabIndex = 0,
  isFirstRewardSent = false,
}) => {
  // currently dependent on one condition only, conditions can be modified later as it is rendering the heading "Occasions" only
  const showOccasions = diwaliGifting || holidayGifting || false;
  const {
    kybStatus: { kyb_status = 0 } = {},
    userBalance: { currencyCode = "INR" } = {},
    plumGifting = [],
  } = accountReducer;
  const history = useHistory();
  const url = history.location.pathname + history.location.hash;
  const [selectedOption, setSelectedOption] = useState(url);
  useEffect(() => {
    const url = history.location.pathname + history.location.hash;
    setSelectedOption(url);
  }, [history.location.hash]);

  const [showSidebar, setShowSidebar] = useState(true);
  const [isSidebarHovered, setIsSidebarHovered] = useState(false);

  const styling = {
    maxWidth: showSidebar ? "246px" : "20px",
    minWidth: showSidebar ? "246px" : "20px",
    height: "calc(100vh - 52px)",
    transition: "all 0.1s ease",
    backgroundColor: theme.palette.common.white,
  };

  useEffect(() => {
    if (onClick) {
      let initialSelectedOption = options?.findIndex((option) =>
        selectedOption?.includes(option.url)
      );
      if (initialSelectedOption === -1) {
        initialSelectedOption = 0;
      }
      onClick(initialSelectedOption || 0);
    }
    if (!history.location.hash && onClick) {
      setSelectedOption(`/${app_path}/${options[0].url}`);
    }
  }, [selectedOption]);

  useEffect(() => {
    if (activeTabIndex) {
      onClick && onClick(activeTabIndex);
      setSelectedOption(`/${app_path}/${options[activeTabIndex].url}`);
    }
  }, [activeTabIndex]);

  useEffect(() => {
    if (history?.location?.title) {
      let newSelectedOption = options?.findIndex((option) =>
        option.url.includes(history.location?.title)
      );
      onClick && onClick(newSelectedOption || 0);
      setSelectedOption(
        `${history?.location?.pathname}#${history.location?.title}`
      );
    }
  }, [history?.location?.title]);
  const dismissKyb = JSON.parse(sessionStorage.getItem("dismissKyb")) || false;
  const NavbarOpenClose = () => {
    return (
      <span
        style={{
          position: "fixed",
          top:
            (!dismissKyb && !isFirstRewardSent) ||
            (accountReducer?.mfaData?.res?.length &&
              accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1)
              ? "122px"
              : "72px",
          left: showSidebar ? "280px" : "54px",
          zIndex: "99",
          transform: showSidebar ? "rotate(180deg)" : "",
          transition: "all 0.1s ease",
        }}
      >
        <Tooltip
          tooltip={showSidebar ? "Collapse" : "Expand"}
          placement="bottom"
        >
          <span
            style={{
              display: "inline-block",
              height: "32px",
              width: "32px",
              borderRadius: "100%",
              border: `1px solid  ${theme.palette.light.c300}`,
              backgroundColor: theme.palette.common.white,
            }}
            className="d-flex align-items-center justify-content-center cursor-pointer"
          >
            <Icon iconName="PlumChevronRight" />
          </span>
        </Tooltip>
      </span>
    );
  };
  let moduleAclArray = accountReducer?.moduleAcl?.map(
    (item) => item?.module_id
  );
  return (
    <div
      style={{
        ...styling,
        borderRight: `1px solid ${theme.palette.light.c300}`,
      }}
      onMouseEnter={() => {
        setIsSidebarHovered(true);
      }}
      onMouseLeave={() => {
        if (showSidebar) {
          setIsSidebarHovered(false);
        }
      }}
    >
      <div
        onClick={() => {
          setShowSidebar(!showSidebar);
        }}
        style={{
          opacity: isSidebarHovered ? "1" : "0",
          transition: "all 0.05s ease",
        }}
      >
        <NavbarOpenClose />
      </div>

      <div
        style={{
          ...styling,
          overflow: "hidden",
          borderRight: `1px solid ${theme.palette.light.c300}`,
          position: "fixed",
          top:
            (!dismissKyb && !isFirstRewardSent) ||
            (accountReducer?.mfaData?.res?.length &&
              accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1) ||
            kyb_status === 6 ||
            kyb_status === 7
              ? "92px"
              : "52px",
          transition: "all 0.1s ease",
          zIndex: 9,
        }}
      >
        <div
          style={{
            height: "100%",
            opacity: showSidebar ? "1" : "0",
            paddingTop: "24px",
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingBottom:
              (!dismissKyb && !isFirstRewardSent) ||
              (accountReducer?.mfaData?.res?.length &&
                accountReducer?.mfaData?.res?.[0]?.skip_mfa == 1) ||
              kyb_status === 6 ||
              kyb_status === 7
                ? "62px"
                : "24px",
          }}
          className="d-flex flex-column overflow-auto"
        >
          <Typography.ButtonText
            className={`${
              title?.toLowerCase() === "send rewards" ? "mb-0" : "mb-24"
            }`}
          >
            {title}
          </Typography.ButtonText>
          {title?.toLowerCase() === "send rewards" && (
            <div>
              <hr className="w-100" />
              <Typography.HelperText
                color="dark"
                shade="c200"
                className="ml-8 mb-4"
                style={{ fontSize: "12px" }}
              >
                Reward Types
              </Typography.HelperText>
            </div>
          )}
          <div>
            {options.map((option, index) =>
              option.show ? (
                <SubOption
                  active={selectedOption?.includes(option.url)}
                  key={option.title}
                  onClick={() => {
                    if (option.url) history.push(`/${app_path}/${option.url}`);
                    setSelectedOption(`/${app_path}/${option.url}`);
                    onClick && onClick(index);
                  }}
                >
                  {option.title}
                </SubOption>
              ) : (
                ""
              )
            )}
          </div>

          {title?.toLowerCase() === "send rewards" &&
            (moduleAclArray?.includes(ACL_MODULE_MAPPING.XOXO_POINT) ||
              moduleAclArray?.includes(ACL_MODULE_MAPPING.XOXO_LINK) ||
              moduleAclArray?.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
              moduleAclArray?.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER_OPEN)) &&
            plumGifting
              ?.filter(
                (gifting) =>
                  gifting?.items?.length > 0 &&
                  gifting?.items?.filter(
                    (item) =>
                      !item?.currency_code ||
                      (item?.currency_code &&
                        item?.currency_code.length === 0) ||
                      item?.currency_code?.includes(currencyCode)
                  )?.length > 0
              )
              ?.map((gifting) => (
                <>
                  <hr className="w-100" />
                  <Typography.HelperText
                    color="dark"
                    shade="c200"
                    className="ml-8 mb-4"
                    style={{ fontSize: "12px" }}
                  >
                    {gifting?.title}
                  </Typography.HelperText>
                  <div>
                    {gifting?.items
                      ?.filter(
                        (item) =>
                          !item?.currency_code ||
                          (item?.currency_code &&
                            item?.currency_code.length === 0) ||
                          item?.currency_code?.includes(currencyCode)
                      )
                      ?.map((item, index) => (
                        <SubOption
                          active={selectedOption?.includes(
                            item?.title?.toLowerCase()?.replace(/\s+/g, "-")
                          )}
                          key={item?.title}
                          onClick={() => {
                            const url = item?.title
                              ?.toLowerCase()
                              ?.replace(/\s+/g, "-");
                            history.push(`/${app_path}/gifting/${url}`);
                            setSelectedOption(`/${app_path}/gifting/${url}`);
                            onClick && onClick(index);
                          }}
                        >
                          {item?.title}
                        </SubOption>
                      ))}
                  </div>
                </>
              ))}
          {(holidayGiftingCurrencies || []).includes(currencyCode) &&
          showOccasions ? (
            <>
              {moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
              moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ? (
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  className="mt-20 ml-8 mb-4"
                >
                  Occasions
                </Typography.BodySmall>
              ) : null}
              <div>
                {getEventRewardOptions(accountReducer?.moduleAcl).map(
                  (option, index) =>
                    option.show ? (
                      <SubOption
                        active={selectedOption?.includes(option.url)}
                        key={option.title}
                        onClick={() => {
                          if (intercomChecklistId) {
                            try {
                              if (kyb_status === 2) {
                                startChecklist(intercomChecklistId);
                              } else {
                                startChecklist(intercomChecklistIdNonKyb);
                              }
                            } catch (e) {
                              console.error("Error in intercomm checklist", e);
                            }
                          }
                          if (option.url)
                            history.push(`/${app_path}/${option.url}`);
                          setSelectedOption(`/${app_path}/${option.url}`);
                          onClick && onClick(index);
                        }}
                      >
                        {option.title}
                      </SubOption>
                    ) : (
                      ""
                    )
                )}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default OptionSideBar;
